export const GROUP_CONFIG_STYLES = {
  portalTextRow: [{
    column: 0,
    styles: {
      margin: "8px 32px 0 0",
      minWidth: 140
    }
  }],
  checkboxRow: [{
    column: 0,
    styles: {
      margin: "8px 32px 19px 0",
      minWidth: 140,
      display: "flex"
    }
  }],
  singleLongText: [{
    column: 0,
    styles: {
      margin: "8px 32px 0 0",
      width: 400
    }
  }],
  singleConfig: [{
    column: 1,
    styles: {
      width: 120,
      marginTop: 8,
      marginRight: 0
    }
  }, {
    column: 2,
    styles: {
      width: 120,
      marginTop: 8,
      display: "flex"
    }
  }],
  configFirst: [{
    column: 1,
    styles: {
      width: 120,
      marginTop: 8,
      marginRight: 0
    }
  }, {
    column: 2,
    styles: {
      width: 80,
      marginTop: 8,
      marginRight: 0
    }
  }, {
    column: 3,
    styles: {
      width: 120,
      marginTop: 8
    }
  }],
  configLast: [{
    column: 1,
    styles: {
      width: 120,
      marginTop: 8,
      marginRight: 32
    }
  }, {
    column: 2,
    styles: {
      width: 120,
      marginTop: 8,
      marginRight: 0
    }
  }, {
    column: 3,
    styles: {
      width: 80,
      marginTop: 8
    }
  }]
};